import React, { ReactElement } from 'react';
import { CellProps } from 'react-table';

export function TwoLineTruncatedCell<T extends Record<string, unknown>>({
  value,
}: CellProps<T>): ReactElement {
  return <span className="truncate-two-lines">{value}</span>;
}
